<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            TagPhotos
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in 5" class="item" :style="getItemStyle()" :key="index">
               
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TagPhotosProp",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,

        }
    },
    methods: {
        getTitleStyle() {
            return 'margin-left: ' + this.obj.tag_photos_params.margin + 'px;';
        },
        getListBoxStyle() {
            return 'padding-left: ' + this.obj.tag_photos_params.margin + 'px;' +
                'padding-bottom: ' + this.obj.tag_photos_params.margin + 'px;' +
                'gap:' + this.obj.tag_photos_params.between_space + 'px;';
        },
        getItemStyle() {
            return 'width:' + this.obj.tag_photos_params.item_width + 'px;' +
                'height:' + this.obj.tag_photos_params.item_height + 'px;' +
                'line-height:' + this.obj.tag_photos_params.item_height + 'px;' +
                'border-radius:' + this.obj.tag_photos_params.corner_radius + 'px;';
        }
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    line-height: 40px;
}

.list-box {
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;

    .item {
        display: inline-block;
        background-color: #d8d7d7;
        text-align: center;
        font-size: small;
        flex-shrink: 0;
    }
}
</style>